import microsoft from "assets/images/brands/microsoft.png";
import mail_chimp from "assets/images/brands/mail_chimp.png";
import img5 from "assets/images/companies/img-5.png";
import img7 from "assets/images/companies/img-7.png";
import img6 from "assets/images/companies/img-6.png";
import img3 from "assets/images/companies/img-3.png";
import img2 from "assets/images/companies/img-2.png";
import img1 from "assets/images/companies/img-1.png";
import dribbble from "assets/images/brands/dribbble.png";
import github from "assets/images/brands/github.png";

const agencies = [
    {
        id: 1,
        since: "2013",
        img: { priview: microsoft, formattedSize: "4.87 KB", path: "img-1.png", size: '3000' },
        imgalt: "microsoft.png",
        name: "Microsoft",
        location: "Brasília, Brazil",
        property: "7620",
        employee: "36",
        email: "microsoft@steex.com",
        contact: "(33) 3521-6761",
        joiningdate: "17 Mar, 2023",
        status: "Active",
    }, {
        id: 2,
        since: "2001",
        img: { priview: mail_chimp, formattedSize: "4.87 KB", path: "img-2.png", size: '3020' },
        imgalt: "mail_chimp.png",
        name: "Mail Chimp",
        location: "California, USA",
        property: "1095",
        employee: "10",
        email: "mail_chimp@steex.com",
        contact: "(53) 3035-3100",
        joiningdate: "15 Mar, 2023",
        status: "Unactive",
    }, {
        id: 3,
        since: "1998",
        img: { priview: img5, formattedSize: "4.87 KB", path: "img-3.png", size: '3300' },
        imgalt: "img-5.png",
        name: "Themesbrand",
        location: "Sobrado, Spain",
        property: "953",
        employee: "17",
        email: "themesbrand@steex.com",
        contact: "(21) 2345-6789",
        joiningdate: "11 Mar, 2023",
        status: "Active",
    }, {
        id: 4,
        since: "1983",
        img: { priview: img7, formattedSize: "4.87 KB", path: "img-4.png", size: '3400' },
        imgalt: "img-7.png",
        name: "Pich Hub",
        location: "San Luis Potosi, Mexico",
        property: "3248",
        employee: "50",
        email: "pichhub@steex.com",
        contact: "(11) 3666-9716",
        joiningdate: "29 Mar, 2023",
        status: "Active",
    }, {
        id: 5,
        since: "2009",
        img: { priview: img6, formattedSize: "4.87 KB", path: "img-5.png", size: '3050' },
        imgalt: "img-6.png",
        name: "Rotic Fashion",
        location: "Ibiza, Spain",
        property: "4985",
        employee: "55",
        email: "rotic@steex.com",
        contact: "(92) 3639-8685",
        joiningdate: "24 Mar, 2023",
        status: "Unactive",
    }, {
        id: 6,
        since: "2012",
        img: { priview: img3, formattedSize: "4.87 KB", path: "img-6.png", size: '3700' },
        imgalt: "img-3.png",
        name: "Terry & Jerry",
        location: "Guarulhos, Brazil",
        property: "3214",
        employee: "64",
        email: "terry@steex.com",
        contact: "(11) 3885-1022",
        joiningdate: "18 Mar, 2023",
        status: "Active",
    }, {
        id: 7,
        since: "2004",
        img: { priview: img2, formattedSize: "4.87 KB", path: "img-7.png", size: '3060' },
        imgalt: "img-2.png",
        name: "Brand Infosys",
        location: "California, USA",
        property: "1095",
        employee: "10",
        email: "brand_infosys@steex.com",
        contact: "(53) 3035-3100",
        joiningdate: "27 Mar, 2023",
        status: "Unactive",
    }, {
        id: 8,
        since: "1996",
        img: { priview: img1, formattedSize: "4.87 KB", path: "img-8.png", size: '3080' },
        imgalt: "img-1.png",
        name: "Pich Fashion",
        location: "Natal, Brazil",
        property: "1258",
        employee: "37",
        email: "pichfashion@steex.com",
        contact: "(51) 3233-7909",
        joiningdate: "21 Mar, 2022",
        status: "Active",
    }, {
        id: 9,
        since: "1994",
        img: { priview: dribbble, formattedSize: "4.87 KB", path: "img-9.png", size: '3009' },
        imgalt: "dribbble.png",
        name: "Dribbble",
        location: "Hamburg, Germany",
        property: "1023",
        employee: "49",
        email: "dribbble@steex.com",
        contact: "(27) 3041-1766",
        joiningdate: "08 Mar, 2022",
        status: "Active",
    }, {
        id: 10,
        since: "1980",
        img: { priview: github, formattedSize: "4.87 KB", path: "img-10.png", size: '3010' },
        imgalt: "github.png",
        name: "GitHub",
        location: "Birmingham, United Kingdom",
        property: "954",
        employee: "32",
        email: "github@steex.com",
        contact: "(86) 9985-9220",
        joiningdate: "25 Mar, 2022",
        status: "Unactive",
    }, {
        id: 11,
        since: "2009",
        img: { priview: img6, formattedSize: "4.87 KB", path: "img-11.png", size: '3011' },
        imgalt: "img-6.png",
        name: "Rotic Fashion",
        location: "Ibiza, Spain",
        property: "4985",
        employee: "55",
        email: "rotic@steex.com",
        contact: "(92) 3639-8685",
        joiningdate: "19 Mar, 2022",
        status: "Active",
    }
];

export { agencies };